import moment from 'jalali-moment'

export const dateFormater1 = (src) => {
  if (src) {
    let helperDate = new Date(src);
    let day = helperDate.toLocaleDateString("fa-IR", { day: "numeric" });
    let month = helperDate.toLocaleDateString("fa-IR", { month: "long" });
    return `${day} ${month} ${src.split("-")[0]}`;
  } else {
    return "";
  }
};
export const dateFormater = (date) => {
  let day = new Date(date).toLocaleDateString("fa-IR", { day: "2-digit" });
  let month = new Date(date).toLocaleDateString("fa-IR", { month: "long" });
  let year = new Date(date).toLocaleDateString("fa-IR", { year: "numeric" });
  return `${day} ${month} ${year}`;
};

export const formatedDateWP = (date) => {
  let day = new Date(date).toLocaleDateString("fa-IR", {
    day: "2-digit",
  })
  let month = new Date(date).toLocaleDateString("fa-IR", {
    month: "long",
  })
  let year = new Date(date).toLocaleDateString("fa-IR", {
    year: "numeric",
  })
  return `${day} ${month} ${year}`
};

export const jDateFormatter = (src) =>{
  if (src) {
    let date = moment.from(src , 'fa' , 'YYYY/MM/DD').locale('fa');
    let day = date.format('DD');
    let month = date.format('MMMM');
    let year = date.format('YYYY');
    return `${day} ${month} ${year}`;
  } else {
    return ""
  }

}